import React, { Component } from 'react';
import TopNavbar from '../../components/Admin/TopNavbar';
import LeftSidebar from '../../components/Admin/LeftSidebar';
import withAuth from '../../helpers/withAuth';
import CouponsTable from '../../components/Admin/coupons/CouponsTable';

class Coupons extends Component {
  render() {
    return (
      <React.Fragment>
        <TopNavbar />
        <LeftSidebar />

        <CouponsTable />
      </React.Fragment>
    );
  }
}

export default withAuth(Coupons);
